import { Controller } from "@hotwired/stimulus"
import { celebrate } from "../lib/confetti"

// Persists across the turbo-stream replacements that swap this element after a
// triage action, so the controller can tell a real "just hit zero" transition
// (last thread in the current filter got triaged away) from a page that simply
// loaded already at zero (no celebration on first paint). Reset on every full
// Turbo Drive visit — switching to a different filter combination that never
// had any matches is not the user clearing a queue, even though it also lands
// on unread zero, so it must not inherit the previous page's count.
let lastUnread = null
document.addEventListener("turbo:before-visit", () => { lastUnread = null })

export default class extends Controller {
  static values = { unread: Number, review: Number }

  connect() {
    window.dispatchEvent(new CustomEvent("feed-progress:updated", { detail: { unread: this.unreadValue, review: this.reviewValue } }))
    if (lastUnread !== null && lastUnread > 0 && this.unreadValue === 0) celebrate()
    lastUnread = this.unreadValue
  }
}
